import { clsx } from 'clsx';
import styles from './styles.css';
import { Button } from '@cian/ui-kit';
import { useAppDispatch } from 'shared/hooks';
import { setVisible } from 'shared/slices';

interface IModalFailedProps {
  image: string;
  title: string;
  description: string;
}

export const ModalFailed: React.FC<IModalFailedProps> = ({ image, title, description }) => {
  const dispatch = useAppDispatch();

  const handleBack = () => {
    dispatch(setVisible(false));
  };

  return (
    <div className={styles['container']}>
      <div className={clsx(styles['image'], styles[image])} />
      <div className={styles['textblock']}>
        <div className={styles['title']}>{title}</div>
        <div className={styles['description']}>{description}</div>
      </div>
      <div className={styles['btn']}>
        <Button onClick={handleBack}>Назад</Button>
      </div>
    </div>
  );
};
